// Геометрия ряда «малый · средний · большой» в легенде дрейфа.
//
// Считается ИЗ ТОЙ ЖЕ таблицы радиусов, что красит карту (DRIFT_GRADE_RADIUS).
// Раньше кружки легенды были нарисованы вручную радиусами 2.5/4/6 против 5/8/12
// на карте — ровно вдвое мельче, и «большой» в легенде выглядел как «средний»
// на карте. Легенда обязана быть образцом, а не иллюстрацией.
import { DRIFT_GRADE_RADIUS } from './driftMarkerStyle'

/** Просвет между кружками, px. */
export const GRADE_LEGEND_GAP = 6

export interface LegendCircle {
  cx: number
  cy: number
  r: number
}

export interface LegendScale {
  width: number
  height: number
  circles: LegendCircle[]
}

/** Ряд кружков по возрастанию, в тех же пикселях, что и маркеры карты. */
export function gradeLegendScale(gap: number = GRADE_LEGEND_GAP): LegendScale {
  const radii = [
    DRIFT_GRADE_RADIUS.small,
    DRIFT_GRADE_RADIUS.medium,
    DRIFT_GRADE_RADIUS.large,
  ]
  const height = 2 * Math.max(...radii)
  const cy = height / 2

  const circles: LegendCircle[] = []
  let x = 0
  for (const r of radii) {
    circles.push({ cx: x + r, cy, r })
    x += 2 * r + gap
  }
  const last = circles[circles.length - 1]
  return { width: last.cx + last.r, height, circles }
}
